<script setup lang="ts">
</script>

<template>
    <slot></slot>
</template>

<style scoped lang="scss"></style>
